import React, { FC } from 'react'
import { NotificationCampaignForm } from '../components/notification-campaign-form';

/**
 * Tawreed  User Form Page
 * @returns 
 */
export const NotificationCampaignPage: FC = () => (<NotificationCampaignForm />);

